// extracted by mini-css-extract-plugin
module.exports = {"actionContainer":"SampleNameRenderer_actionContainer_Nx4nj","textoverflow":"SampleNameRenderer_textoverflow_1_tpu"};